import { render, staticRenderFns } from "./orderReportDetail.vue?vue&type=template&id=5344ae81&scoped=true&"
import script from "./orderReportDetail.vue?vue&type=script&lang=js&"
export * from "./orderReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderReportDetail.vue?vue&type=style&index=0&id=5344ae81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344ae81",
  null
  
)

export default component.exports